/**
 * Wall/Barrier Definitions
 *
 * Defines different wall types that can be placed to slow/block enemies.
 */
// ============================================================================
// WALL DEFINITIONS
// ============================================================================
export const WALL_DEFINITIONS = {
    basic: {
        type: 'basic',
        name: 'Pole Siłowe',
        description: 'Podstawowa bariera energetyczna, spowalnia wrogów o 50%',
        baseHp: 100,
        width: 2,
        height: 3,
        goldCost: 50,
        slowPercent: 0.50,
        allowsFriendlies: false,
        color: 0x00ccff, // Cyan energy
    },
    reinforced: {
        type: 'reinforced',
        name: 'Tarcza Plazmowa',
        description: 'Wzmocniona bariera z 3x HP, spowalnia o 75%',
        baseHp: 300,
        width: 2,
        height: 3,
        goldCost: 150,
        slowPercent: 0.75,
        allowsFriendlies: false,
        color: 0xff00ff, // Magenta plasma
    },
    gate: {
        type: 'gate',
        name: 'Brama Fazowa',
        description: 'Przepuszcza sojuszników, blokuje wrogów',
        baseHp: 150,
        width: 2,
        height: 3,
        goldCost: 100,
        slowPercent: 0.25,
        allowsFriendlies: true,
        color: 0x00ff88, // Green phase
    },
};
// ============================================================================
// HELPER FUNCTIONS
// ============================================================================
/**
 * Get wall definition by type
 */
export function getWallDefinition(type) {
    return WALL_DEFINITIONS[type];
}
/**
 * Get all wall types
 */
export function getAllWallTypes() {
    return Object.keys(WALL_DEFINITIONS);
}
/**
 * Check if player can afford a wall
 */
export function canAffordWall(type, gold) {
    const def = WALL_DEFINITIONS[type];
    return gold >= def.goldCost;
}
//# sourceMappingURL=walls.js.map